const label = (shortcode) =>
  shortcode.charAt(0).toUpperCase() + shortcode.slice(1);

const GREENHOUSE_ONBOARDING_SHORTCODES = ['copperstate', 'cresco', 'urbnleaf'];

export const greenhouseOnboardingEventTypeInfo = Object.fromEntries(
  GREENHOUSE_ONBOARDING_SHORTCODES.map((shortcode) => [
    `greenhouse-onboarding-${shortcode}`,
    { label: label(shortcode) }
  ])
);
